import React, { useMemo } from 'react';
import { Box, Typography, List, ListItem, ListItemText, Chip, Divider } from '@mui/material';

const roleLabel = (role) => {
    if (role === 'user') {
        return 'Du';
    }
    if (role === 'system') {
        return 'System';
    }
    return 'Schreiberlein Bot';
};

export default function ChatWindow({ messages }) {
    const items = useMemo(() => messages ?? [], [messages]);

    return (
        <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', px: 2, py: 1 }} data-testid="chatbot-window">
            <List dense sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {items.length === 0 && (
                    <ListItem disableGutters>
                        <ListItemText
                            primary={
                                <Typography variant="body2" color="text.secondary">
                                    Noch keine Unterhaltung – starte mit einer Frage oder einer Schnellaktion.
                                </Typography>
                            }
                        />
                    </ListItem>
                )}
                {items.map((message, index) => (
                    <React.Fragment key={`${index}-${message.text?.slice(0, 12) ?? 'msg'}`}>
                        <ListItem
                            disableGutters
                            sx={{
                                flexDirection: 'column',
                                alignItems: message.role === 'user' ? 'flex-end' : 'flex-start',
                                gap: 0.5,
                            }}
                        >
                            <Chip size="small" label={roleLabel(message.role)} color={message.role === 'user' ? 'primary' : 'default'} />
                            <Box
                                sx={{
                                    bgcolor: message.role === 'user' ? 'primary.main' : 'grey.100',
                                    color: message.role === 'user' ? 'primary.contrastText' : 'text.primary',
                                    px: 1.5,
                                    py: 1,
                                    borderRadius: 2,
                                    maxWidth: '85%',
                                    whiteSpace: 'pre-wrap',
                                }}
                            >
                                <Typography variant="body2">{message.text}</Typography>
                            </Box>
                        </ListItem>
                        {index < items.length - 1 && <Divider component="li" light />}
                    </React.Fragment>
                ))}
            </List>
        </Box>
    );
}
